// App branding
export const APP = {
  name: 'DIY X-treme',
  tagline: 'Learn skills. Solve problems. Work smarter.',
  short: 'DIYX',
};
